import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useDietaryGoals() {
  const [dietaryGoals, setDietaryGoals] = useState<{ [key: string]: string }>();

  useEffect(() => {
    const getDietaryGoals = async () => {
      try {
        const res = await Api.Dietitian.listDietaryGoals();
        setDietaryGoals(res.data);
      } catch (error) {}
    };
    getDietaryGoals();
  }, []);
  return dietaryGoals;
}
